import { BaseClass } from '@/components/BaseClass.js';
const stylesheet = new CSSStyleSheet();
stylesheet.replaceSync(`
  :host {
    display: flex;
    width: 100%;
  }
  
  :host * {
    color: unset;
  }
  
  svg {
    width: 100%;
    height: 100%;
    color: inherit;
  }
`);
export class RIcon extends BaseClass {
    constructor() {
        super();
        this.shadowRoot.adoptedStyleSheets.push(stylesheet);
        if (!this.url)
            throw new Error('Attribute "url" is missing.');
        this.#loadSVG();
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = ``;
    }
    get url() {
        return this.getAttribute('url');
    }
    #loadSVG() {
        return fetch(this.url).then(r => r.text()).then(r => this.shadowRoot.innerHTML = r);
    }
}
customElements.define('r-icon', RIcon);
